import {
  ActivityCategoryDTO,
  ActivityDTO,
  ActivityStatus,
  ApiListRequest,
  ApiListResponse,
} from "@gymflow/types";
import { infiniteQueryOptions, QueryKey } from "@tanstack/react-query";

import { api } from "../../api";
import { numberPagination } from "../../numberPagination";

const keys = {
  all: () => ["hostedApiActivity"] as QueryKey,
  list: (filter: unknown) => [...keys.all(), "list", filter] as QueryKey,
  listCategories: (filter: unknown) =>
    [...keys.all(), "listCategories", filter] as QueryKey,
};

export const hostedApiActivity = {
  keys,
  queries: {},
  infiniteQueries: {
    list: (
      params: {
        status?: ActivityStatus;
        id?: number[];
      } & ApiListRequest,
    ) =>
      infiniteQueryOptions({
        queryKey: keys.list(params),
        queryFn: async ({ pageParam }) => {
          return (
            await api.get<ApiListResponse<ActivityDTO>>(`/hosted/activity`, {
              params: { ...params, page: pageParam },
            })
          ).data;
        },
        ...numberPagination,
      }),
    listCategories: (
      params: {
        statusList?: ActivityStatus[];
      } & ApiListRequest,
    ) =>
      infiniteQueryOptions({
        queryKey: keys.listCategories(params),
        queryFn: async ({ pageParam }) => {
          return (
            await api.put<ApiListResponse<ActivityCategoryDTO>>(
              `/hosted/activity/category/search`,
              {
                ...params,
                page: pageParam,
              },
            )
          ).data;
        },
        ...numberPagination,
      }),
  },
  mutations: {},
};
